export default "__VITE_ASSET__Chy71tr5__"